/* eslint-disable react/jsx-one-expression-per-line */
import LocationFilled from '@pe-libs/react-components/build/components/PeIcons/LocationFilled.svg';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC } from 'react';
import { InferType } from 'yup';
import { singleResultSchema } from '#modules/expertDirectory/schemas/searchDirectory';
import messages from './messages';
import useStyles from './styles';

type Props = {
  address: InferType<typeof singleResultSchema>['address'];
  websiteUrl: string;
  websiteAnchor: string;
  email?: string;
};

const ContactDetails: FC<Props> = ({
  address: { phone, street, zipCode, city, state },
  websiteUrl,
  email,
  websiteAnchor,
}) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const phoneNumber = phone && phone.replace(/[ ()-]/g, '');

  return (
    <div className={styles.contactDetailsContainer}>
      <div className={styles.locationDetails}>
        <PeTypography variant="body1" className={styles.address}>
          <LocationFilled />
          {`${street ? `${street}` : ''}${zipCode || city ? ', ' : ''}${zipCode ? `${zipCode}` : ''}${
            city ? ` ${city}` : ''
          }${state ? `, ${state}` : ''}`}
        </PeTypography>
      </div>

      <div className={styles.contactDetails}>
        {phone && (
          <PeLink
            title={formatMessage(messages.hoverTel, { phoneNumber })}
            href={`tel:${phoneNumber}`}
            rel="nofollow noopener"
          >
            {`${formatMessage(messages.phoneLabel)} ${phone}`}
          </PeLink>
        )}
        {email && (
          <PeLink
            title={formatMessage(messages.hoverEmail, { email })}
            href={`mailto:${email}`}
            onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => event.stopPropagation()}
            rel="nofollow noopener"
          >
            {email}
          </PeLink>
        )}
        {websiteUrl && (
          <PeLink
            target="_blank"
            href={websiteUrl}
            rel="nofollow noopener"
            className={styles.cutLongLink}
            title={formatMessage(messages.hoverWebsiteUrl, { website: websiteUrl })}
          >
            {websiteAnchor}
          </PeLink>
        )}
      </div>
    </div>
  );
};

export default ContactDetails;
